export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "prvafirma-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "prvafirma-themeWrapLive" */'./LiveThemeImporter'),
  },
};
